import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroArrowLeftSolid } from '@ng-icons/heroicons/solid';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-code-authentication',
  imports: [CommonModule, ReactiveFormsModule, NgIcon, RouterModule],
  providers: [AuthService, provideIcons({ heroArrowLeftSolid })],
  templateUrl: './code-authentication.component.html',
  styleUrl: './code-authentication.component.scss',
})
export class CodeAuthenticationComponent {
  auth = inject(AuthService);
  router = inject(Router);
  route = inject(ActivatedRoute);

  private fb = inject(FormBuilder);
  otpTempCode: string = '';

  authenticationForm: FormGroup = this.fb.group({
    code: ['', [Validators.required, Validators.minLength(6)]],
  });

  constructor() {
    this.route.queryParams.subscribe((params) => {
      this.otpTempCode = params['code'] || null;
    });
  }

  async onSubmit(): Promise<void> {
    const otp = this.authenticationForm.value.code;
    this.auth.verifyOtp({ otp_temp_code: this.otpTempCode, otp });
  }
}
